import { useCallback } from "react"
import { useSession } from "../providers/supabase"

/**
 * Hook that provides JWT authentication headers for backend API requests
 */
export function useBackendAuth() {
  const session = useSession()
  const accessToken = session?.access_token

  const getAuthHeaders = useCallback((): Record<string, string> => {
    if (!accessToken) return {}
    return { 'Authorization': `Bearer ${accessToken}` }
  }, [accessToken])

  return {
    getAuthHeaders,
    isAuthenticated: !!accessToken,
  }
}